"use client";

import CountryContactPage from "@/components/Contact/CountryContactPage";

export default function Singapore() {
  return <CountryContactPage headquarters="sg" />;
}
